
// Home page product tabs js
	
$('.custom__shop-list').click(function () {
    var $this = $(this); // The clicked menu item
    var $theTab = $this.attr('data-attr'); // Get the data-tab value
    console.log("Clicked tab ID:", $theTab);
    
    var $tabsWrapper = $this.closest('.mega-menu__list'); // Wrapper of the menu items
    console.log("Tabs Wrapper:", $tabsWrapper);
    
    // Targeting the content based on the clicked menu item's 'data-attr' attribute
    var $tabContent = $('#' + $theTab);
    console.log("Target content:", $tabContent);

    // Only change the content if it's not already marked as 'current'
    if (!$this.hasClass('current')) {
        // Remove 'current' class from all tabs and their content
        $tabsWrapper.find('.custom__shop-list').removeClass('custom_active');
        $('.custom_submenu-list').removeClass('custom_active');
        
        // Add 'current' class to the clicked tab and its corresponding content
        $this.addClass('custom_active');
        $tabContent.addClass('custom_active');
    }
});

	$('ul.coll-tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.coll-tabs li').removeClass('current');
		$('.coll-product').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	});

// Customer circle animation
document.addEventListener("DOMContentLoaded", function() {
  const circles = document.querySelectorAll('.progress-circle');

  circles.forEach(circle => {
    const percentage = circle.getAttribute('data-percentage');
    const circlePath = circle.querySelector('.circle');
    
    // Calculate the stroke-dasharray for the percentage
    const dashArray = `${(percentage / 100) * 100}, 100`;
    circlePath.style.strokeDasharray = dashArray;
  });
});

// real scince tabs
$(document).ready(function(){
$('ul.science-tabs li').click(function () {
    var $this = $(this); // The clicked tab
    var $theTab = $this.attr('data-tab'); // Get the data-tab value
    console.log("Clicked tab ID:", $theTab);
    var $tabsWrapper = $this.closest('.science-tabs-list');
    console.log("Tabs Wrapper:", $tabsWrapper);
    var $tabContent = $('.tab-content.science-text[id="' + $theTab + '"]');
    console.log("Target content:", $tabContent);

    if (!$this.hasClass('current')) {
        $tabsWrapper.find('ul.science-tabs li').removeClass('current');
       $('.tab-content.science-text').removeClass('current');
        $this.addClass('current');
        $tabContent.addClass('current');
    }
});
});

// Swiper slider

$(document).ready(function() {
// Swiper: Slider
    new Swiper('.swiper-container', {
        loop: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    });
});
// text-carousel
document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('.text-carousel__slides');
  const prev = document.querySelector('.prev-slide');
  const next = document.querySelector('.next-slide');
  const dots = document.querySelectorAll('.dot');
  const slides = document.querySelectorAll('.text-carousel__slide');

  let currentIndex = 0;

  function updateCarousel(index) {
    currentIndex = index;
    carousel.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    updateDots();
  }

  function updateDots() {
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentIndex);
    });
  }

  prev.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateCarousel(currentIndex);
  });

  next.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % slides.length;
    updateCarousel(currentIndex);
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      updateCarousel(index);
    });
  });

  // Initialize dots and carousel
  updateDots();
});

// Footer accordion
document.querySelectorAll('.accordion-toggle').forEach(button => {
  button.addEventListener('click', () => {
    // Close any open accordions except the clicked one
    document.querySelectorAll('.accordion-toggle').forEach(otherButton => {
      if (otherButton !== button) {
        otherButton.classList.remove('active');
        otherButton.nextElementSibling.style.display = 'none';
      }
    });

    // Toggle the clicked accordion
    const content = button.nextElementSibling;
    const isOpen = button.classList.contains('active');

    if (isOpen) {
      button.classList.remove('active');
      content.style.display = 'none';
    } else {
      button.classList.add('active');
      content.style.display = 'block';
    }
  });
});
